import { CurrentPlatform } from '../enums';

const MOBILE_MEDIA_QUERY = `(max-width: ${768}px)`;

export const isIosDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const getPlatformFromViewport = (): CurrentPlatform => {
  if (typeof window === 'undefined') {
    return CurrentPlatform.desktop;
  }
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches
    ? CurrentPlatform.mobile
    : CurrentPlatform.desktop;
};

export const subscribeToViewportPlatform = (
  callback: (platform: CurrentPlatform) => void,
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => {
      // no-op: обработка по умолчанию
    };
  }
  const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
  const listener = () => callback(getPlatformFromViewport());
  mediaQueryList.addEventListener('change', listener);
  return () => mediaQueryList.removeEventListener('change', listener);
};
